import styled, { createGlobalStyle } from "styled-components";

export const QuillGlobalStyles = createGlobalStyle`
    .ql-editor {
        font-family: 'Montserrat', sans-serif;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: 'Normal';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value]::before {
        content: attr(data-value);
    }
`;

export const Container = styled.div`
    border: ${(props) => props.displayBorder};

    .editor-style-text {
        outline: none;
        cursor: default;
    }

    .wrapper-class {
        padding: 1rem;
    }

    .editor-class {
        background-color: #ececea75;
        padding: 1rem;
        border-radius: 4px;
        opacity: 1;
    }

    .toolbar-class {
        background-color: transparent;
        opacity: 1;
    }

    .rdw-link-modal {
        left: auto;
        right: 0;
    }
`;
